export default "images/open.png";